import * as React from "react";

function IconFacebook(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16z"
        fill="#fff"
      />
      <path
        d="M13.556 13.333h-2V16h2v8h3.333v-8h2.428l.239-2.667h-2.667v-1.111c0-.637.128-.889.743-.889h1.924V8h-2.539c-2.397 0-3.461 1.055-3.461 3.077v2.256z"
        fill="#4267B2"
      />
    </svg>
  );
}

export default IconFacebook;
